// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ChartController from "./chart_controller";
application.register("chart", ChartController);

import TinymceController from "./tinymce_controller";
application.register("tinymce", TinymceController);

import NestedFormController from "./nested_form_controller";
application.register("nested-form", NestedFormController);

import TooltipController from "./tooltip_controller";
application.register("tooltip", TooltipController);
